module.exports = __webpack_public_path__ + "static/media/header_congreso_union.112651c6.jpg";